import React from 'react';
import GaugeChart from 'react-gauge-chart';
import "./GaugeChart.scss"
import { Flex } from 'antd';


const SmallGauge = ({ percent = 0.78 }) => {
  return (
    <div style={{ width: "90px", overflow: "hidden" }}>
      <GaugeChart
        id="gauge-chart-small"
        nrOfLevels={3}
        colors={['#B7332A', '#F0922A', '#4CB55C']}
        arcWidth={0.3}
        percent={percent}
        hideText={true}
        cornerRadius={0}
        arcsLength={[0.33, 0.33, 0.34]}
        height={50}
        needleColor="#3C3C3C"
        needleHeightRatio={2}  // increased from 0.70 to 0.95 for taller needle
        arcPadding={0}
      />
      <Flex className='down-numbers' >
        <span>0</span>
        <span>100</span>
      </Flex>
    </div>
  );
};

export default SmallGauge;
